import { render, staticRenderFns } from "./complianceEdit.vue?vue&type=template&id=2cb886f8&"
import script from "./complianceEdit.vue?vue&type=script&lang=js&"
export * from "./complianceEdit.vue?vue&type=script&lang=js&"
import style0 from "./complianceEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports